/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowActivity200ResponseDataUser } from './ShowActivity200ResponseDataUser';
import {
    ShowActivity200ResponseDataUserFromJSON,
    ShowActivity200ResponseDataUserFromJSONTyped,
    ShowActivity200ResponseDataUserToJSON,
    ShowActivity200ResponseDataUserToJSONTyped,
} from './ShowActivity200ResponseDataUser';

/**
 * 
 * @export
 * @interface ShowEvent200ResponseData
 */
export interface ShowEvent200ResponseData {
    /**
     * 
     * @type {number}
     * @memberof ShowEvent200ResponseData
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowEvent200ResponseData
     */
    organizerId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    typeLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    startsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    endsAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    lat?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    lng?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowEvent200ResponseData
     */
    maxParticipants?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShowEvent200ResponseData
     */
    photoUrls?: Array<string>;
    /**
     * 
     * @type {ShowActivity200ResponseDataUser}
     * @memberof ShowEvent200ResponseData
     */
    organizer?: ShowActivity200ResponseDataUser;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowEvent200ResponseData
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowEvent200ResponseData interface.
 */
export function instanceOfShowEvent200ResponseData(value: object): value is ShowEvent200ResponseData {
    return true;
}

export function ShowEvent200ResponseDataFromJSON(json: any): ShowEvent200ResponseData {
    return ShowEvent200ResponseDataFromJSONTyped(json, false);
}

export function ShowEvent200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEvent200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organizerId': json['organizer_id'] == null ? undefined : json['organizer_id'],
        'title': json['title'] == null ? undefined : json['title'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'description': json['description'] == null ? undefined : json['description'],
        'type': json['type'] == null ? undefined : json['type'],
        'typeLabel': json['type_label'] == null ? undefined : json['type_label'],
        'startsAt': json['starts_at'] == null ? undefined : json['starts_at'],
        'endsAt': json['ends_at'] == null ? undefined : json['ends_at'],
        'locationName': json['location_name'] == null ? undefined : json['location_name'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'maxParticipants': json['max_participants'] == null ? undefined : json['max_participants'],
        'photoUrls': json['photo_urls'] == null ? undefined : json['photo_urls'],
        'organizer': json['organizer'] == null ? undefined : ShowActivity200ResponseDataUserFromJSON(json['organizer']),
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowEvent200ResponseDataToJSON(json: any): ShowEvent200ResponseData {
    return ShowEvent200ResponseDataToJSONTyped(json, false);
}

export function ShowEvent200ResponseDataToJSONTyped(value?: ShowEvent200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizer_id': value['organizerId'],
        'title': value['title'],
        'slug': value['slug'],
        'description': value['description'],
        'type': value['type'],
        'type_label': value['typeLabel'],
        'starts_at': value['startsAt'],
        'ends_at': value['endsAt'],
        'location_name': value['locationName'],
        'city': value['city'],
        'country': value['country'],
        'lat': value['lat'],
        'lng': value['lng'],
        'max_participants': value['maxParticipants'],
        'photo_urls': value['photoUrls'],
        'organizer': ShowActivity200ResponseDataUserToJSON(value['organizer']),
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

